import React, { Fragment } from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import cn from 'classnames';

import Icon from '../Icon';
import Controls from '../ContentArea/Controls';
import ClickableElement from '../ClickableElement';
import ControlsItem from '../ContentArea/ControlsItem';
import { BREAKPOINT, COLORS } from '../../constants/styles';
import styles from './index.styl';

const ContextBar = ({
  contextSubtitle,
  contextTitle,
  transparent,
  onClick,
  expanded,
  title,
}) => (
  <Fragment>
    <If condition={!expanded}>
      {title && <div styleName="barTitle">{title}</div>}
      <Else />
      <div styleName={cn('bar', { transparent })}>
        <Controls>
          <ControlsItem fixed>
            <ClickableElement onClick={onClick} ariaLabel="back arrow">
              <MediaQuery maxWidth={BREAKPOINT}>
                {isMobile => (
                  <Icon
                    name={isMobile ? 'arrow-down' : 'back-arrow'}
                    size={16}
                    style={{
                      transform: isMobile ? 'rotate(90deg)' : null,
                      fill: COLORS.white,
                    }}
                  />
                )}
              </MediaQuery>
            </ClickableElement>
          </ControlsItem>
        </Controls>
        <div styleName="text-wrapper">
          <span className="f-12 pr2" styleName="subtitle">
            {contextSubtitle}
          </span>
          <span className="f-14" styleName="title">
            {contextTitle}
          </span>
        </div>
      </div>
    </If>
  </Fragment>
);

ContextBar.propTypes = {
  contextSubtitle: PropTypes.string,
  contextTitle: PropTypes.string,
  onClick: PropTypes.func,
  expanded: PropTypes.bool,
  title: PropTypes.string,
  transparent: PropTypes.bool,
};

export default CSSModules(ContextBar, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/ContextBar/index.jsx